import { ActionIcon, type ActionIconProps } from '@mantine/core';
import type { CSSProperties } from 'react';

type Variant = 'transparent' | 'secondary';

type IconButtonProps = Omit<ActionIconProps, 'variant' | 'style'> & {
  variant?: Variant;
  onClick?: () => void;
  style?: CSSProperties;
  children: React.ReactNode;
  'aria-label'?: string;
  'data-testid'?: string;
};

// Mirrors the Button design system's variants so an icon-only control sits
// alongside a labelled one without drifting from it.
const VARIANT_PROPS: Record<Variant, Partial<ActionIconProps>> = {
  transparent: { variant: 'transparent' },
  secondary: { variant: 'transparent', bg: 'brand.0', c: 'brand.7' },
};

export function IconButton({
  style,
  children,
  variant = 'transparent',
  ...props
}: IconButtonProps) {
  return (
    <ActionIcon {...VARIANT_PROPS[variant]} {...props} style={{ borderRadius: 20, ...style }}>
      {children}
    </ActionIcon>
  );
}
